import { getBaseSignature } from "selectors/base"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getViewType, getPeriod, getSelectedModelId, getIsExpanded, getIsActive, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getBaseStartDate } from "modules/portfolio-root/selectors/base"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getStartDate, getEndDate, getDriftDates, getAiSummaryStartDate } from "selectors/dates"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getFilteredData, getCategoryItemsSubset, getPassthroughResourcesStatus } from "./selectors/data"
import { getSelectedViews, getDisplayAddView } from "selectors/factors"
import { getOptions, getSelectedOption } from "./selectors/options"
import { getDrift } from "./selectors/drift"
import { getDisplayType, getAvailableSelectViewFactors, getScaleIds, getShowSegment } from "./selectors/items"
import { getFileName } from "./selectors/file"
import { getDatesAdjusted } from "./selectors/dates"
import { getAttributionMethod, getFirstRiskDate, getLastRiskDate, getRiskSelectedDate, getMCTEAdjustedSegment, getMCTEAdjustedBase } from "./selectors/risk"
import { getIsOpPro } from "modules/account-root/selectors"
import { getFiltersVisible } from "modules/analyze-header/selectors"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    portfolioId: state.global.selected.portfolio,
    account: state.global.selected.account,
    modelId: getSelectedModelId(state, props),
    startDate: getStartDate(state, props),
    endDate: getEndDate(state, props),
    aiSummaryStartDate: getAiSummaryStartDate(state, props),
    viewType: getViewType(state, props),
    isActive: getIsActive(state, props),
    base: getMCTEAdjustedBase(state, props),
    baseSignature: getBaseSignature(state, props),
    baseStartDate: getBaseStartDate(state, props),
    driftDates: getDriftDates(state, props),
    segment: getMCTEAdjustedSegment(state, props),
    expand: getIsExpanded(state, props),
    currency: getCurrency(state, props),
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state, props),
    attributionMethod: getAttributionMethod(state, props),
  }),
  required: ["account", "portfolioId", "modelId"],
  data: [{
    resource: "analyzeRisk",
    as: null,
    passthrough: true,
    url: ({ modelId, portfolioId, startDate, base, driftDates, baseSignature, baseStartDate, isActive, segment, expand, currency, attributionMethod, fxHedgeEnabled }) => {
      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate
      const fetchStartDate = isActive && baseStartDate && from < baseStartDate ? baseStartDate : from

      return {
        id: `analyzeRisk-${modelId}${portfolioId}${fetchStartDate}${to}${isActive}${baseSignature}${JSON.stringify(segment)}${expand}${currency}${attributionMethod}${fxHedgeEnabled}`,
        query: `query ($modelId: String!, $portfolioId: String!, $from: Date!, $to: Date!, $base: [PositionSetInput], $segment: Segment, $expand: Boolean) {
          model (id: $modelId) {
            simulation (positionSet: {
              type: PORTFOLIO,
              id: $portfolioId,
              segment: $segment,
              expand: $expand
            }, from: $from, to: $to, base: $base, interval: AUTO) {
              risk {
                date
                total
                attribution {
                  summary {
                    factors
                    specific
                  }
                  factors {
                    id
                    category
                    name
                    value
                  }
                }
              },
            }
          }
        }`,
        variables: {
          modelId,
          portfolioId,
          from: fetchStartDate,
          to,
          base: isActive ? [base] : undefined,
          segment,
          expand,
        },
      }
    },
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    drift: getDrift(state, props),
    firstDate: getFirstRiskDate(state, props),
    selectedDate: getRiskSelectedDate(state, props),
    lastRiskDate: getLastRiskDate(state, props),
    options: getOptions(state, props),
    fileName: getFileName(state, props),
    period: getPeriod(state, props),
    selectedOption: getSelectedOption(state, props),
    ...state.modules.analyzeRisk,
    displayType: getDisplayType(state, props),
    filtersVisible: getFiltersVisible(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    selectedViews: getSelectedViews(state, props),
    displayAddView: getDisplayAddView(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    yScaleIds: getScaleIds(),
    showSegment: getShowSegment(state, props),
    passthroughResourcesStatus: getPassthroughResourcesStatus(state, props),
    isOpPro: getIsOpPro(state),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setDate,
    resetDate: PortfolioRootCreators.resetDate,
    setPeriod: PortfolioRootCreators.setPeriod,
    addSelectedView: PortfolioRootCreators.addSelectedView,
    removeSelectedView: PortfolioRootCreators.removeSelectedView,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
})
